import { ReactElement } from "react";

export const Pipes = ():ReactElement => {
  return (
    <div className={'pipes-animated'}>
      <div className={'pa__pipe pa__pipe_1'}>
        <div className={'flow flow_pink'}/>
      </div>
      <div className={'pa__pipe pa__pipe_2'}>
        <div className={'flow flow_green'}/>
      </div>
    </div>
  )
}